import { useState } from 'react';
import {createClient} from "../../services/Administrative/clientsService";

export const useRegisterClient = () => {
    const [loading, setLoading] = useState(false);

    const registerClient = async (newClientDTO: any) => {
        setLoading(true);
        try {
            const response:any = await createClient(newClientDTO);
            return response.data.data.client;
        } catch (error: any) {
            throw error.message;
        } finally {
            setTimeout(() => setLoading(false), 600);
        }
    };

    return { registerClient, loading };
};
